import { render, staticRenderFns } from "./FileMovementsTable.vue?vue&type=template&id=c05e6fc2&"
import script from "./FileMovementsTable.vue?vue&type=script&lang=js&"
export * from "./FileMovementsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports